export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "bg": {
        "binance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изисквайте исторически данни за клинове за определен символ за определен период от време. За начертаване на линейни диаграми в данните за полезен товар използвайте време и цена на затваряне."])},
        "chart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Създайте линейна диаграма с исторически цени на затваряне за времевите серии и променете цената на тик."])}
      },
      "en": {
        "binance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request historical klines data for a certain symbol over a specified time period. For drawing line charts inside payload data, use time and close price."])},
        "chart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a line chart with historical close prices for the time series and change the tick price."])}
      },
      "tr": {
        "binance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belirli bir süre boyunca belirli bir sembol için geçmiş kline verilerini isteyin. Yük verileri içinde çizgi grafikleri çizmek için zaman ve kapanış fiyatını kullanın."])},
        "chart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fiyat grafiği için kapanış fiyatlarıyla bir çizgi grafik oluşturun ve son işlem fiyatını güncelleyin."])}
      }
    }
  })
}
